// extracted by mini-css-extract-plugin
export default {"orgPackUpDiv":"orgActivityPackUpload_orgPackUpDiv__emwiv"};